module.exports = __webpack_public_path__ + "media/images/athletes/1169-56fbdf9c0526874b10ccb91e48b25150.png";